import { useEffect, useState } from "react";
import { usePageNameContext } from "../../contexts/PageTitleContext";
import useDefaultCRUDHandlers from "../../hooks/useDefaultCRUDHandlers";
import LoadingWheel from "../../components/shared/LoadingWheel";
import ShippingPoliciesTable from "../../components/shippingPolicies/ShippingPoliciesTable";
import useShippingPolicies from "../../data/useShippingPolicies";
import { ButtonInput } from "../../components/shared/Inputs/ButtonInput";
import { PlusIcon } from "@heroicons/react/24/outline";
import ShippingPolicyModal from "../../components/shippingPolicies/ShippingPoliciesModal";
import { setOptions } from 'react-chartjs-2/dist/utils';
import openInNewTab from './../../utils/openInNewTab';
import { IShippingPolicy } from './../../models/ShippingPolicy';


export default function ShippingPolicies() {
  const { setInfo } = usePageNameContext();
  const { saveHandlers } = useDefaultCRUDHandlers("Admin Settings");
  const { shippingPolicies } = useShippingPolicies();
  const [open, setOpen] = useState(false);
  const [selectedPolicy, setSelectedPolicy] = useState<IShippingPolicy | undefined>(undefined);


  useEffect(() => {
    setInfo({
      name: "Shipping Policies",
      desc: "View and configure your shipping policies",
    });
  }, []);

  const handleEditPolicy = (policy: IShippingPolicy) => {
    setSelectedPolicy(policy);
    setOpen(true);
  };

  const handleAddNewPolicy = () => {
    setSelectedPolicy(undefined);
    setOpen(true);
  };

  if (shippingPolicies.isLoading) {
    return (
      <div>
        <LoadingWheel />
      </div>
    )
  } else {
    return (
      <>
        <ShippingPolicyModal open={open} setOpen={setOpen} policy={selectedPolicy} />
        <div>
          <ButtonInput isSubmit={false} onClick={() => handleAddNewPolicy()} classes={undefined} >
            <div className="bg-primary-600 px-3 py-2 shadow rounded text-white flex items-center">
              <PlusIcon className="h-5 w-5 mr-2" />
              Add New Shipping Policy
            </div>
          </ButtonInput>

          <ShippingPoliciesTable
            policies={shippingPolicies.data?.data!}
            onEditClick={handleEditPolicy}
          />
        </div>
      </>
    )
  }
}